import React from 'react';
import { AccordionDetails, List, ListItem } from '@mui/material';

interface HelpVideoAccordianComponentProps {
    VideoLinks: string[];
}

const HelpVideoAccordianComponent: React.FC<HelpVideoAccordianComponentProps> = ({ VideoLinks }) => {
  const parseVideoLink = (link: string) => {
    // Here you can parse and convert the link if necessary to ensure it is an embeddable URL
    // For example, convert YouTube links to embeddable format
    if (link.includes('youtube.com/watch?v=')) {
      return link.replace('watch?v=', 'embed/');
    }
    return link; // return the link as is if no conversion is needed
  };

  return (
    <AccordionDetails>
      <List>
        {VideoLinks?.map((video, index) => (
          <ListItem key={index}>
            <iframe
              width="560"
              height="315"
              src={parseVideoLink(video)}
              title={`Video ${index + 1}`}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </ListItem>
        ))}
      </List>
    </AccordionDetails>
  );
};

export default HelpVideoAccordianComponent;
